export default "You can think of this as like \"background noise\", random sounds that obscure what we're trying to hear.\n"